import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";

class EntityReports extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Entity Reports</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/entities/tee-time-request-engagement'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Tee-Time Request Engagement
                                </h3>
                                <p className='card-text'>
                                    View the percentage of entity members who
                                    have made a tee-time request.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/entities/completed-tee-time-booking-engagement'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Completed Tee-Time Bookings
                                </h3>
                                <p className='card-text'>
                                    View the percentage of entity members who
                                    have made a completed tee-time booking.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/entities/booking-activity-threshold'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Booking Activity Threshold
                                </h3>
                                <p className='card-text'>
                                    View entity members below or at/above a
                                    booking activity threshold.
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default EntityReports;
